import Lazy from '../helpers/Lazy';

;$(function() {

	var lazies = $(document).find('.lazy');

	if (! lazies.length)
		return;

	let credits = [];
	let general = [];

	for (let element_i = 0; element_i < lazies.length; element_i++) {
		let element = lazies.eq(element_i);
		if (element.data('c') == 'car' && element.data('m') == 'credit')
			credits.push(element.data('i'));
		else
			general.push(element);
	}

	Lazy.credits(credits).then(results => {
		for (let carun in results) {
			let element = $(document).find('.lazy[data-i="' + carun + '"][data-c="car"][data-m="credit"]');
			Lazy.replace(element, results[carun]);
		}
	})
	Lazy.load(general);

});